/**
 * How certificate types read on screen.
 *
 * The enum names are schema identifiers — API_Q1, NACE_MR0175,
 * MILL_TEST_CERTIFICATE — and passing them through a generic title-caser
 * produces "Api_q1" and "Nace_mr0175", which are not the names of anything. An
 * API specification is written API Q1 and a compliance officer will not
 * recognise it written any other way.
 */
const LABELS: Record<string, string> = {
  MILL_TEST_CERTIFICATE: 'Mill test certificate',
  CERTIFICATE_OF_CONFORMANCE: 'Certificate of conformance',
  API_Q1: 'API Q1',
  API_Q2: 'API Q2',
  NACE_MR0175: 'NACE MR0175',
  ISO_CERTIFICATION: 'ISO certification',
  MTR: 'Mill test report',
  COC: 'Certificate of conformance',
  COA: 'Certificate of analysis',
  CALIBRATION: 'Calibration',
  SAFETY: 'Safety',
  ENVIRONMENTAL: 'Environmental',
  QUALITY: 'Quality',
  OTHER: 'Other',
};

export function certificateTypeLabel(type: string): string {
  return LABELS[type] ?? type.replace(/_/g, ' ');
}
